// Text för den aktiva Outlet Båstad-webbplatsen. Alla språk har samma nycklar.
export const translations = {
  "sv": {
    "meta": {
      "title": "Outlet Båstad – kända varumärken till outletpriser i Östra Karup",
      "description": "Outlet Båstad i Östra Karup – skor och kläder för dam, herr och barn från kända varumärken till outletpriser. Vid E6:ans norra infart till Båstad, bredvid Willab Garden.",
      "ogTitle": "Outlet Båstad – kända varumärken till outletpriser",
      "ogDescription": "Skor och kläder för dam, herr och barn. Tomtaholmsvägen 1, Östra Karup – vid E6:ans norra infart till Båstad.",
      "ogLocale": "sv_SE"
    },
    "language": {
      "choose": "Välj språk",
      "sv": "Svenska",
      "da": "Dansk",
      "en": "English"
    },
    "nav": {
      "home": "Hem",
      "main": "Huvudmeny",
      "brands": "Varumärken",
      "about": "Om butiken",
      "find": "Hitta hit",
      "contact": "Kontakta oss"
    },
    "social": {
      "follow": "Följ Outlet Båstad"
    },
    "hero": {
      "welcome": "Välkommen till",
      "categories": "Skor · Kläder · Dam · Herr · Barn",
      "tagline": "Kända varumärken till riktigt bra priser – för hela familjen.",
      "photoAlt": "Outlet Båstads fasad med skylten Skor, Kläder, Dam, Herr, Barn och entrén en solig dag",
      "address": "Adress",
      "hours": "Öppettider",
      "phone": "Telefon",
      "mapTitle": "Vägbeskrivning",
      "mapLine1": "Klicka här för att",
      "mapLine2": "få vägbeskrivningen",
      "weekdayHours": "Måndag–fredag 10–18",
      "weekendHours": "Lördag 10–16 · Söndag 11–16",
      "open": "Öppet nu",
      "closed": "Stängt nu",
      "closesAt": "Stänger kl.",
      "opensToday": "Öppnar idag kl.",
      "opensTomorrow": "Öppnar i morgon kl.",
      "discountRange": "20–70 %",
      "discountLabel": "lägre priser"
    },
    "brands": {
      "label": "I butiken",
      "title": "Välkända varumärken",
      "note": "Utbudet varierar – här är några av varumärkena du kan hitta i butiken.",
      "aria": "Varumärken",
      "pause": "Pausa logotyper",
      "resume": "Starta logotyper"
    },
    "stop": {
      "title": "Därför stannar man här",
      "brandTitle": "Kända märken",
      "brandCopy": "Ett noga utvalt sortiment av populära varumärken.",
      "priceTitle": "Outletpriser",
      "priceCopy": "Samma kvalitet, bättre priser.",
      "locationTitle": "Perfekt läge",
      "locationCopy": "Precis vid E6:ans norra infart till Båstad, bredvid Willab Garden."
    },
    "intro": {
      "title": "En butik värd ett stopp.",
      "first": "Du hittar Outlet Båstad i Båstadporten, bredvid Willab Garden, precis vid E6:ans norra infart till Båstad.",
      "second": "Här samlas mode, sport och skor från välkända varumärken i en enkel och lättillgänglig butiksmiljö för dam, herr och barn.",
      "imageAlt": "Butiksmiljö inne på Outlet Båstad",
      "eveningAlt": "Outlet Båstads fasad och entré med upplyst skylt i kvällsljus"
    },
    "visit": {
      "address": "Adress",
      "landmark": "Vid Båstadporten, bredvid Willab Garden, vid E6:ans norra infart till Båstad.",
      "openMap": "Öppna i Google Maps →",
      "hours": "Öppettider",
      "weekday": "Måndag–fredag 10–18",
      "saturday": "Lördag 10–16",
      "sunday": "Söndag 11–16",
      "contact": "Kontakt"
    },
    "contact": {
      "label": "Kontakt",
      "title": "Hör av dig",
      "intro": "Har du en fråga om butiken, sortimentet eller något annat? Skicka ett meddelande så återkommer vi.",
      "call": "Ring oss",
      "name": "Namn",
      "email": "E-post",
      "phone": "Telefon",
      "optional": "valfritt",
      "message": "Meddelande",
      "honeypot": "Lämna detta fält tomt",
      "privacyStart": "Dina uppgifter används för att besvara ditt meddelande. Läs vår ",
      "privacyLink": "information om personuppgifter",
      "privacyEnd": ". Skriv inte känsliga uppgifter i meddelandet.",
      "submit": "Skicka meddelande",
      "sending": "Skickar…",
      "success": "Tack! Ditt meddelande har skickats.",
      "error": "Det gick inte att skicka just nu. Ring oss gärna på 0431-700 45."
    },
    "footer": {
      "visit": "Besök oss",
      "call": "Ring oss",
      "privacy": "Integritet & personuppgifter",
      "credit": "Hemsida skapad av"
    }
  },
  "da": {
    "meta": {
      "title": "Outlet Båstad – kendte mærker til outletpriser i Skåne",
      "description": "Besøg Outlet Båstad ved Båstadporten i Skåne. Sko, tøj og sport til dame, herre og børn fra kendte mærker. Tæt på E6 og Willab Garden.",
      "ogTitle": "Outlet Båstad – kendte mærker til outletpriser",
      "ogDescription": "Sko, tøj og sport til hele familien. Tomtaholmsvägen 1, Östra Karup, ved E6-afkørslen nord for Båstad.",
      "ogLocale": "da_DK"
    },
    "language": {
      "choose": "Vælg sprog",
      "sv": "Svenska",
      "da": "Dansk",
      "en": "English"
    },
    "nav": {
      "home": "Forside",
      "main": "Hovedmenu",
      "brands": "Mærker",
      "about": "Om butikken",
      "find": "Find vej",
      "contact": "Kontakt os"
    },
    "social": {
      "follow": "Følg Outlet Båstad"
    },
    "hero": {
      "welcome": "Velkommen til",
      "categories": "Sko · Tøj · Dame · Herre · Børn",
      "tagline": "Sport- og fritidsoutlet i Skåne – kendte mærker til rigtig gode priser for hele familien.",
      "photoAlt": "Outlet Båstads facade og indgang på en solskinsdag",
      "address": "Adresse",
      "hours": "Åbningstider",
      "phone": "Telefon",
      "mapTitle": "Vejvisning",
      "mapLine1": "Klik her for at",
      "mapLine2": "få rutevejledning",
      "weekdayHours": "Mandag–fredag 10–18",
      "weekendHours": "Lørdag 10–16 · Søndag 11–16",
      "open": "Åbent nu",
      "closed": "Lukket nu",
      "closesAt": "Lukker kl.",
      "opensToday": "Åbner i dag kl.",
      "opensTomorrow": "Åbner i morgen kl.",
      "discountRange": "20–70 %",
      "discountLabel": "lavere priser"
    },
    "brands": {
      "label": "I butikken",
      "title": "Kendte mærker",
      "note": "Udvalget varierer – her er nogle af de mærker, du kan finde i butikken.",
      "aria": "Mærker",
      "pause": "Sæt logoer på pause",
      "resume": "Start logoer"
    },
    "stop": {
      "title": "Derfor er det værd at stoppe",
      "brandTitle": "Kendte mærker",
      "brandCopy": "Et nøje udvalgt sortiment af populære mærker.",
      "priceTitle": "Outletpriser",
      "priceCopy": "Samme kvalitet, bedre priser.",
      "locationTitle": "God beliggenhed",
      "locationCopy": "Lige ved E6-afkørslen nord for Båstad, ved siden af Willab Garden."
    },
    "intro": {
      "title": "En butik, der er værd at stoppe ved.",
      "first": "Du finder Outlet Båstad ved Båstadporten i Skåne, ved siden af Willab Garden og lige ved E6-afkørslen nord for Båstad.",
      "second": "Her finder du tøj, sport og sko fra kendte mærker til dame, herre og børn i en overskuelig og lettilgængelig butik.",
      "imageAlt": "Inde i Outlet Båstads butik",
      "eveningAlt": "Outlet Båstads oplyste facade og indgang om aftenen"
    },
    "visit": {
      "address": "Adresse",
      "landmark": "Ved Båstadporten, ved siden af Willab Garden, ved E6-afkørslen nord for Båstad.",
      "openMap": "Åbn i Google Maps →",
      "hours": "Åbningstider",
      "weekday": "Mandag–fredag 10–18",
      "saturday": "Lørdag 10–16",
      "sunday": "Søndag 11–16",
      "contact": "Kontakt"
    },
    "contact": {
      "label": "Kontakt",
      "title": "Skriv til os",
      "intro": "Har du spørgsmål om butikken, sortimentet eller noget andet? Send os en besked, så vender vi tilbage.",
      "call": "Ring til os",
      "name": "Navn",
      "email": "E-mail",
      "phone": "Telefon",
      "optional": "valgfrit",
      "message": "Besked",
      "honeypot": "Lad dette felt stå tomt",
      "privacyStart": "Vi bruger dine oplysninger til at besvare din henvendelse. Læs vores ",
      "privacyLink": "information om personoplysninger",
      "privacyEnd": ". Undlad at skrive følsomme oplysninger i beskeden.",
      "submit": "Send besked",
      "sending": "Sender…",
      "success": "Tak! Din besked er sendt.",
      "error": "Beskeden kunne ikke sendes lige nu. Ring gerne til os på +46 431 700 45."
    },
    "footer": {
      "visit": "Besøg os",
      "call": "Ring til os",
      "privacy": "Privatliv og personoplysninger",
      "credit": "Hjemmeside skabt af"
    }
  },
  "en": {
    "meta": {
      "title": "Outlet Båstad – well-known brands at outlet prices in Skåne",
      "description": "Visit Outlet Båstad near Båstad in southern Sweden. Shoes, clothing and sportswear for women, men and children from well-known brands, next to the E6 and Willab Garden.",
      "ogTitle": "Outlet Båstad – well-known brands at outlet prices",
      "ogDescription": "Shoes, clothing and sportswear for the whole family. Tomtaholmsvägen 1, Östra Karup, by the northern E6 exit for Båstad.",
      "ogLocale": "en_GB"
    },
    "language": {
      "choose": "Choose language",
      "sv": "Svenska",
      "da": "Dansk",
      "en": "English"
    },
    "nav": {
      "home": "Home",
      "main": "Main navigation",
      "brands": "Brands",
      "about": "About the store",
      "find": "Find us",
      "contact": "Contact us"
    },
    "social": {
      "follow": "Follow Outlet Båstad"
    },
    "hero": {
      "welcome": "Welcome to",
      "categories": "Shoes · Clothing · Women · Men · Kids",
      "tagline": "Well-known brands at great outlet prices – for the whole family.",
      "photoAlt": "Outlet Båstad storefront and entrance on a sunny day",
      "address": "Address",
      "hours": "Opening hours",
      "phone": "Phone",
      "mapTitle": "Directions",
      "mapLine1": "Click here for",
      "mapLine2": "directions",
      "weekdayHours": "Monday–Friday 10–18",
      "weekendHours": "Saturday 10–16 · Sunday 11–16",
      "open": "Open now",
      "closed": "Closed now",
      "closesAt": "Closes at",
      "opensToday": "Opens today at",
      "opensTomorrow": "Opens tomorrow at",
      "discountRange": "20–70%",
      "discountLabel": "lower prices"
    },
    "brands": {
      "label": "In store",
      "title": "Well-known brands",
      "note": "Our selection changes – here are some of the brands you may find in store.",
      "aria": "Brands",
      "pause": "Pause logos",
      "resume": "Resume logos"
    },
    "stop": {
      "title": "Why stop here?",
      "brandTitle": "Familiar brands",
      "brandCopy": "A carefully chosen selection of popular brands.",
      "priceTitle": "Outlet prices",
      "priceCopy": "Same quality, better prices.",
      "locationTitle": "Great location",
      "locationCopy": "Right by the northern E6 exit for Båstad, next to Willab Garden."
    },
    "intro": {
      "title": "A store worth stopping for.",
      "first": "You'll find Outlet Båstad at Båstadporten, next to Willab Garden, right by the northern E6 exit for Båstad in southern Sweden.",
      "second": "Explore fashion, sportswear and shoes from well-known brands for women, men and children in a welcoming, easy-to-browse store.",
      "imageAlt": "Inside the Outlet Båstad store",
      "eveningAlt": "Outlet Båstad storefront and illuminated entrance in the evening"
    },
    "visit": {
      "address": "Address",
      "landmark": "At Båstadporten, next to Willab Garden, by the northern E6 exit for Båstad.",
      "openMap": "Open in Google Maps →",
      "hours": "Opening hours",
      "weekday": "Monday–Friday 10–18",
      "saturday": "Saturday 10–16",
      "sunday": "Sunday 11–16",
      "contact": "Contact"
    },
    "contact": {
      "label": "Contact",
      "title": "Get in touch",
      "intro": "Have a question about the store, our selection or anything else? Send us a message and we'll get back to you.",
      "call": "Call us",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "optional": "optional",
      "message": "Message",
      "honeypot": "Leave this field empty",
      "privacyStart": "We use your details to reply to your message. Read our ",
      "privacyLink": "privacy information",
      "privacyEnd": ". Please do not include sensitive information in your message.",
      "submit": "Send message",
      "sending": "Sending…",
      "success": "Thank you! Your message has been sent.",
      "error": "We couldn't send your message right now. Please call us on +46 431 700 45."
    },
    "footer": {
      "visit": "Visit us",
      "call": "Call us",
      "privacy": "Privacy & personal data",
      "credit": "Website created by"
    }
  }
};

export const flags = { sv: "🇸🇪", da: "🇩🇰", en: "🇬🇧" };

export const getLocaleFromPath = (pathname) => {
  const language = pathname.match(/^\/(sv|da|en)(?:\/|$)/)?.[1];
  return language === "da" || language === "en" ? language : "sv";
};

export const homePath = (language) => language === "sv" ? "/" : `/${language}/`;
export const privacyPath = (language) => language === "sv" ? "/integritet.html" : `/${language}/integritet.html`;

